import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useNetworkScope } from '../../hooks/useNetworkScope'

// The permanent slug-free -> slugged shim (TDC-1609).
//
// Brand-client URLs are canonically /portal/:brandSlug/*, but slug-free links
// are scattered across everything we don't control: sent emails, notification
// deep links, Slack messages, bookmarks. Those must keep working forever, so
// this is not a migration aid to delete later.
//
// It reads the FULL location.pathname rather than route params, which is what
// lets the same component sit at two different depths: the root catch-all
// (/orders -> /portal/acme/orders) and the /settings catch-all
// (/settings/team -> /portal/acme/settings/team).
//
// It needs no allowlist of paths to ignore, because React Router's ranking
// already does the discriminating:
//   - internal/pro/expert users never render it (it exists only in the brand
//     branch of generateRoutes);
//   - public and auth routes are siblings of '/*' with static leading
//     segments, so they outrank the splat and <Home/> never mounts for them;
//   - the personal pages that stay at the root are real sibling routes, and a
//     splat ranks below any sibling;
//   - /portal/* matches the portal branch and never reaches here, so it can't
//     loop.
// A genuinely unknown path becomes /portal/acme/<junk>, which the portal
// tree's own catch-all turns into /404 — one extra hop, no loop.
export function PortalRedirect() {
  const { basePath } = useNetworkScope()
  const { pathname, search, hash } = useLocation()

  if (!basePath) return <Navigate to="/404" replace />
  return <Navigate to={{ pathname: `${basePath}${pathname}`, search, hash }} replace />
}
